<template>
  <div class="koutsuuhi edit-item" v-if="editingData">
    <div class="head"><b>通勤手当</b></div>

    <div class="data select-box-adjust">
      <div class="flex flex-align-center">
        <b>非課税</b>
        <div class="hikazei">
          <input-text v-model="editingData.koutsuuhi" :type="'number'" inputmode="numeric"
            class="medium" min="0" max="15000" :error="getError(editingData, 'koutsuuhi')" :disabled="disabled"></input-text>
          <p class="current-data" v-if="currentData">{{ numberFormat(currentData.koutsuuhi) }}</p>
        </div>
        <p class="scale">円</p>
      </div>

      <div class="flex flex-align-center">
        <b>課税</b>
        <div class="kazei">
          <input-text v-model="editingData.koutsuuhi_kazei" :type="'number'" inputmode="numeric" class="medium"
            min="0" max="15000" :error="getError(editingData, 'koutsuuhi_kazei')" :disabled="disabled"></input-text>
          <p class="current-data" v-if="currentData">{{ numberFormat(currentData.koutsuuhi_kazei) }}</p>
        </div>
        <p class="scale">円</p>
      </div>

      <div class="col">
        <p class="pre">{{ Message.CARFARE }}</p>
      </div><!-- col -->
    </div>

  </div>
</template>

<script lang="ts">
import { useForm } from '@/composable/form/form';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { defineComponent } from 'vue';
import Message from "@/const/KoyouKeiyaku/Message";
import { numberFormat } from '@/filters/common';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: []
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup() {
    const { getError } = useForm();
    return {
      getError,
      Message,
      numberFormat
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

b {
  width: 6rem;
}
</style>
